import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { modifier } from "ember-modifier";

export default class extends Component {
  @service http;
  @service abilities;

  instanceId = this.args.instanceId;
  project = this.args.project;

  get cost() {
    return this.fetchCost?.lastSuccessful?.value?.costs?.find((cost) => cost.key === this.instanceId);
  }

  fetchCostForInstance = modifier(() => {
    this.fetchCost.perform();

    return () => this.fetchCost.cancelAll();
  });

  fetchCost = task(async () => {
    if (this.abilities.cannot("access pricing for organization", this.project.organization)) {
      return;
    }

    let { content } = await this.http.request({
      url: `/objectstorage/costs?projectkey=${this.project.id}&instanceid=${this.instanceId}`,
    });

    return content;
  });
}
